import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface TabState {
    tabValue: string
}



const initialState: TabState = {
    tabValue : '1' 
} 



export const tabSlice = createSlice({
    name: 'tabValue',
    initialState,
    reducers: {
        updateTabSession: (state, action: PayloadAction<string>) => {
         
            state.tabValue = action.payload;
        }
    }
});
 
export const {updateTabSession} = tabSlice.actions;

export default tabSlice.reducer;